(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ayzal-homepage"] && !Shopify.designMode) return;
  try {
    
const initAyzalCampaign = () => {
 document.querySelectorAll('[data-ayzal-slider]').forEach(root => {
  if(root.dataset.ready) return;
  const slides=[...root.querySelectorAll('[data-ayzal-slide]')];
  const dots=[...root.querySelectorAll('[data-ayzal-dot]')];
  const pause=root.querySelector('[data-ayzal-pause]');
  if(slides.length<2) return;
  root.dataset.ready='true';
  let current=0, stopped=window.matchMedia('(prefers-reduced-motion: reduce)').matches, timer;
  const show=index => {current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===current);slide.setAttribute('aria-hidden',String(i!==current));});dots.forEach((dot,i)=>{dot.classList.toggle('is-active',i===current);dot.setAttribute('aria-pressed',String(i===current));});};
  const sync=()=>{clearInterval(timer);if(!stopped&&!document.hidden)timer=setInterval(()=>show(current+1),5000);pause.textContent=stopped?'▶':'Ⅱ';pause.setAttribute('aria-label',stopped?pause.dataset.playLabel:pause.dataset.pauseLabel);};
  dots.forEach((dot,i)=>dot.addEventListener('click',()=>{show(i);sync();}));
  pause.addEventListener('click',()=>{stopped=!stopped;sync();});
  root.addEventListener('mouseenter',()=>clearInterval(timer));
  root.addEventListener('mouseleave',sync);
  root.addEventListener('focusin',()=>clearInterval(timer));
  root.addEventListener('focusout',sync);
  document.addEventListener('visibilitychange',sync);
  root.addEventListener('shopify:section:unload',()=>clearInterval(timer));
  show(0);sync();
 });
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAyzalCampaign);else initAyzalCampaign();
document.addEventListener('shopify:section:load',initAyzalCampaign);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ayzal-reviews-drawer"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ayzal-reviews]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const openButton = root.querySelector('[data-ayzal-reviews-open]');
    const overlay = root.querySelector('[data-ayzal-reviews-overlay]');
    const dialog = root.querySelector('[data-ayzal-reviews-dialog]');
    const closeButton = root.querySelector('[data-ayzal-reviews-close]');
    let lastFocused = null;

    const close = () => {
      overlay.hidden = true;
      document.body.classList.remove('ayzal-reviews-open');
      openButton.setAttribute('aria-expanded', 'false');
      lastFocused?.focus();
    };

    const open = () => {
      lastFocused = document.activeElement;
      overlay.hidden = false;
      document.body.classList.add('ayzal-reviews-open');
      openButton.setAttribute('aria-expanded', 'true');
      dialog.focus();
    };

    openButton.addEventListener('click', open);
    closeButton.addEventListener('click', close);
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !overlay.hidden) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
